module.exports = __webpack_public_path__ + "img/webhooks.7a5c40ad.png";